module.exports = __webpack_public_path__ + "img/背孜乡.5cfb3e0e.png";